<div class="bg-white container-lg">
  <main role="main" class="col-md-12 mb-4" *ngIf="datalistsource != undefined">

    <div class="row">
      <div class="col-md-12 d-flex flex-column pt-4">
        <!--         {{datalistsource.filteredData['usr_title_label']}}-->
        <h4 class="pb-2 mb-0 border-bottom">
          {{datalistsource.filteredData['first_name']}} {{datalistsource.filteredData['middle_name']}} {{datalistsource.filteredData['last_name']}}
        </h4>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 d-flex flex-column">
        <div class="my-3 p-3 bg-light flex-grow-1 rounded box-shadow">
          <h6 class="border-bottom border-gray pb-2 mb-0">{{label['loginInfo']}}</h6>
          <div class="media text-muted pt-2">
            <div class="media-body pb-2 mb-0 small lh-125 border-gray">
              <div class="align-items-center w-100 pb-1">
                <div *ngIf="datalistsource.filteredData['username']">
                  <i class="far fa-fw fa-id-badge me-2"></i><strong>{{datalistsource.filteredData['username']}}</strong>
                </div>
                <div *ngIf="datalistsource.filteredData['email']">
                  <i class="far fa-fw fa-envelope me-2"></i>{{datalistsource.filteredData['email']}}
                </div>
                <ng-container *ngIf="datalistsource.filteredData['chosen_language']">
                  <i class="fas fa-fw fa-language me-2"></i> {{label['lngPref']}}: {{datalistsource.filteredData['chosen_language']}}
                </ng-container>
              </div>
            </div>
          </div>
          <ng-container *ngIf="datalistsource.filteredData['position'] !== ''">
            <h6 class="border-bottom border-gray pb-2 pt-2 mb-0">{{label['Position']}}</h6>
            <div class="media text-muted pt-2">
              <div class="media-body mb-0 small lh-125 border-gray">
                <div class="align-items-center w-100 pb-1">
                  <p class="mb-0">{{datalistsource.filteredData['position']}}</p>
                </div>
              </div>
            </div>
          </ng-container>
          <h6 class="border-bottom border-gray pb-2 pt-2 mb-0">{{label['Last_login']}}</h6>
          <div class="media text-muted pt-2">
            <div class="media-body pb-2 mb-0 small lh-125 border-gray">
              <div class="align-items-center w-100 pb-1">
                <ng-container *ngIf="datalistsource.filteredData['last_login']">{{datalistsource.filteredData['last_login']}}<br></ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="col-md-6 d-flex flex-column">
        <div class="my-3 p-3 bg-light flex-grow-1 rounded box-shadow">
          <h6 class="border-bottom border-gray pb-2 mb-0">{{label['Contact_info']}}</h6>

          <div class="media text-muted pt-2">
            <div class="media-body pb-2 mb-0 small lh-125 border-bottom border-gray">
              <div class="align-items-center w-100 pb-1">
                <p class="mb-0">
                  <ng-container *ngIf="datalistsource.filteredData['companyName']">
                    <strong>{{datalistsource.filteredData['companyName']}}</strong>
                    <br>
                  </ng-container>

                  <ng-container
                    *ngIf="datalistsource.filteredData['addressLine1']">{{datalistsource.filteredData['addressLine1']}}
                    <br>
                  </ng-container>

                  <ng-container
                    *ngIf="datalistsource.filteredData['addressLine2']">{{datalistsource.filteredData['addressLine2']}}
                    <br>
                  </ng-container>

                  <ng-container *ngIf="datalistsource.filteredData['zipcode']">
                    {{datalistsource.filteredData['zipcode']}}
                  </ng-container>

                  <ng-container *ngIf="datalistsource.filteredData['city']">
                    {{datalistsource.filteredData['city']}}
                  </ng-container>

                  <ng-container *ngIf="datalistsource.filteredData['state']">
                    {{datalistsource.filteredData['state']}}
                  </ng-container>

                  <ng-container *ngIf="datalistsource.filteredData['country']">
                    {{datalistsource.filteredData['country']}}
                  </ng-container>

                </p>
              </div>
            </div>
          </div>
          <div class="media text-muted pt-2">
            <div class="media-body pb-2 mb-0 small lh-125 border-gray">
              <div class="align-items-center w-100 pb-1">
                <p *ngIf="datalistsource.filteredData['website']" class="mb-0">
                  <i class="fas fa-fw fa-wifi me-2"></i>{{datalistsource.filteredData['website']}}
                </p>
                <p *ngIf="datalistsource.filteredData['mobile']" class="mb-0">
                  <i class="fas fa-fw fa-mobile-alt me-2"></i>{{datalistsource.filteredData['mobile']}}
                </p>
                <p *ngIf="datalistsource.filteredData['phone']" class="mb-0">
                  <i class="fas fa-fw fa-phone-alt me-2"></i>{{datalistsource.filteredData['phone']}}
                </p>
                <p *ngIf="datalistsource.filteredData['fax']" class="mb-0">
                  <i class="fas fa-fw fa-fax me-2"></i>{{datalistsource.filteredData['fax']}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="col-md-12 d-flex flex-column">
        <div class="w-100 text-end py-1">
          <!--          <button [routerLink]="getEditLink(datalistsource.filteredData['id'])" type="button" class="btn btn-sm btn-primary ">-->
          <!--            <i class="fas fa-pen mouse-pointer"></i> {{label['Edit']}}-->
          <!--          </button>-->
        </div>
      </div>

    </div>
  </main>
</div>


